// Drill positions, matching D1's breadcrumb tiers (Manufacturer -> Category ->
// Product Group -> Product Code). "product" is the selectable final scope (Stage 1
// UI upgrade §8.3): it carries totals only, no child rows.
export const LEVELS = {
  MANUFACTURER: "manufacturer",
  CATEGORY: "category",
  GROUP: "group",
  PRODUCT: "product",
};

export const LEVEL_ORDER = [
  LEVELS.MANUFACTURER,
  LEVELS.CATEGORY,
  LEVELS.GROUP,
  LEVELS.PRODUCT,
];

export const LEVEL_LABELS = {
  [LEVELS.MANUFACTURER]: "Manufacturer",
  [LEVELS.CATEGORY]: "Category",
  [LEVELS.GROUP]: "Product Group",
  [LEVELS.PRODUCT]: "Product Code",
};

// The tier of the ROWS shown while positioned at a given level — one level down,
// except at the leaf ("group" positions show product-code rows and there is
// nothing further).
export const CHILD_LEVEL = {
  [LEVELS.MANUFACTURER]: LEVELS.CATEGORY,
  [LEVELS.CATEGORY]: LEVELS.GROUP,
  [LEVELS.GROUP]: LEVELS.PRODUCT,
  [LEVELS.PRODUCT]: null,
};

export const MEASURES = {
  CURRENT: "current",
  REALIZED: "realized",
};

export const MEASURE_LABELS = {
  [MEASURES.CURRENT]: "Current Sales",
  [MEASURES.REALIZED]: "Realized Sales",
};

// Maps the client-toggleable measure (D2) onto the metric field carried by every
// API response (§4.1).
export const MEASURE_METRIC_KEY = {
  [MEASURES.CURRENT]: "currentRevenue",
  [MEASURES.REALIZED]: "realizedRevenue",
};

export const DIMENSIONS = {
  ACCOUNTS: "accounts",
  STATES: "states",
  DISTRIBUTORS: "distributors",
};

export const DIMENSION_LABELS = {
  [DIMENSIONS.ACCOUNTS]: "Top Accounts",
  [DIMENSIONS.STATES]: "Top States",
  [DIMENSIONS.DISTRIBUTORS]: "Top Distributors",
};

export const TOP_PANEL_DEFAULT_LIMIT = 5;
export const TOP_PANEL_MAX_LIMIT = 50;
